exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulelayout[data-v-328a947f]{margin-bottom:18px}.modulelayout__footer[data-v-328a947f]{margin-top:27px;display:-ms-grid;display:grid;-ms-grid-columns:(minmax(200px,1fr))[2];grid-template-columns:repeat(2,minmax(200px,1fr));gap:18px 36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-328a947f","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newprogram/components/modulelayout/ModuleLayout.vue
// module id = b10947f13d577c20b4d4
// module chunks = 10